import type { Dictionary } from 'lodash';

import { Badge } from '@mcdougald/ui/src';

const TagsToNamesMap = {
  'Trevor McDougald': 'Me',
} as unknown as Record<string, string>;

const convertTagNamesToValues = (tagName: string): string => {
  return TagsToNamesMap[tagName] ?? tagName;
};

/**
 * TODO: Should update query on click
 */
export const RenderPostsTags = (props: {
  tags: Array<[string, number]>;
  filteredTagList: Dictionary<number>;
}) => {
  const FilteredTagList = props.filteredTagList;
  return (
    <div className={'tags-container flex flex-wrap gap-2 mb-8 max-w-[600px]'}>
      {props.tags.map(([tagName, tagValue]: [string, number], i) => {
        const isFiltered = Boolean(
          FilteredTagList[tagName] && FilteredTagList[tagName] < tagValue,
        );

        return (
          <Badge
            key={`${tagName}-${i}`}
            variant={'ghost'}
            className={isFiltered ? 'opacity-50' : 'opacity-100'}
          >
            {convertTagNamesToValues(tagName)}{' '}
            <span className={'font-normal ml-2'}>({tagValue})</span>
          </Badge>
        );
      })}
    </div>
  );
};
